import { theme } from "./model";
import store from '../store'

const changeStyle = (obj) => {
    for (let key in obj){
        document.getElementsByTagName("body")[0]
            .style.setProperty(`--${key}`, obj[key])
    }
}

// 改变主题
export const setTheme = (themeName) => {
    store.commit("setThemeName", themeName);
    if(themeName){
        const themeConfig = theme[themeName];
        changeStyle(themeConfig);
    } else {
        store.commit("setThemeName", 'dark');
        const themeConfig = theme['dark'];
        changeStyle(themeConfig);
    }
}
